import { createFileRoute } from "@tanstack/react-router";
import { useCallback, useState } from "react";

import { BoardImagesGate } from "#/game/BoardImagesGate";
import { GameStoreProvider } from "#/game/GameStoreProvider";
import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";
import { TutorialBoard } from "#/tutorial/TutorialBoard";
import { createTutorialInitialState } from "#/tutorial/tutorialGame";

export const Route = createFileRoute("/tutorial")({
  head: () => documentHead(DOCUMENT_TITLES.tutorial),
  component: TutorialPage,
});

function TutorialPage() {
  const [session, setSession] = useState(() => ({
    runId: 0,
    initialState: createTutorialInitialState(),
  }));
  const handleRestart = useCallback(
    () => setSession((s) => ({ runId: s.runId + 1, initialState: createTutorialInitialState() })),
    [],
  );

  return (
    <BoardImagesGate state={session.initialState}>
      <GameStoreProvider
        key={session.runId}
        initialState={session.initialState}
        initialServerDayNumber={session.initialState.currentDay}
      >
        <TutorialBoard onRestart={handleRestart} />
      </GameStoreProvider>
    </BoardImagesGate>
  );
}
